import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {RealmService} from '../Services/Realm/realm.service';
import {ApiService} from '../Services/Api/api.service';
import {SessionService} from '../Services/Session/session-service.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {AuthService} from '../auth.service';
import {Router} from '@angular/router';
import {ConfirmationService, MessageService} from 'primeng/api';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css', '../../assets/layout/style/layout.css']
})
export class SettingsComponent implements OnInit {
  types = [];
  userform: FormGroup;
  submitted: boolean;
  items: any[];
  countryTitle: string;
  selectedCity: string;
  phoneTitle: string;
  emailTitle: string;
  dpiTitle: string;
  loginBtnTitle: string;
  fcmToken: string;
  masks = 'dd/MM/yyyy';
  selectedType = 0;
  sessionResponse: any;
  product: any = [];
  selectedProducts: any[];
  userData: any;
  constructor(private realm: RealmService, private api: ApiService, private st: SessionService,
              private Rc: FirebaseService, private fb: FormBuilder, private auth: AuthService,
              private router: Router, private messageService: MessageService, private confirmationService: ConfirmationService, private dp: DatePipe) {
  }

  ngOnInit() {
    
    
    
    this.types = [];
    this.types.push({ label: 'Sesiones Activas', value: 0 });
    this.types.push({ label: 'Actualizar Datos', value: 1 });
    this.realm.getSessionSettings()
    
    this.Rc.fetchActivate().then(() => {
      console.log('pais:::::: ', this.Rc.getStringRC('global_select_country_title'));
      this.phoneTitle = this.Rc.getStringRC('global_phone_number');
      this.dpiTitle = this.Rc.getStringRC('global_number_id');
      this.emailTitle = this.Rc.getStringRC('global_email_address');
      this.loginBtnTitle = this.Rc.getStringRC('global_accept');
      this.countryTitle = this.Rc.getStringRC('global_select_country_title');
    });
    
    this.realm.getCountriesArea().then((data:any) => {
      this.items = data.data.countryCodeAppSettingsOrms;
    })
    
    this.userform = this.fb.group({
      phoneNumber: new FormControl('', [Validators.required, Validators.minLength(4)]),
      dpi: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required)
    });
    this.selectedCity = this.userform.get('country').value;

    this.st.getData('user').then( (data: any) => {
      this.userData = data;
      let phone:string = data.phoneNumber;
      let dpi = data.documentId;
      let email = data.email;
      let country = data.phoneArea;
      let cnArea = '+'+country;
      //console.log("email: "+ email);
      //console.log("phone: "+ phone);
      //console.log("country: "+ country);
      let cnSel = this.items.find((cn:any) => { console.log("idCode: "+ cn.idCode); return cn.idCode == cnArea});
      this.userform.get("phoneNumber").setValue(phone.slice(4));
      this.userform.get("dpi").setValue(dpi);
      this.userform.get("email").setValue(email);
      this.userform.get("country").setValue(cnSel);
    });
  }
  ngAfterViewInit() {
    console.log("afterViewInit");
    

    this.api.responseSessions$.subscribe( data => {
    const dat = JSON.parse(JSON.stringify(data));
    console.log('data ws Session: ', data);
    if (dat.code === 701) {
        const s: any = dat.resultSessionLogs;
        if (s.hasOwnProperty('success')) {
          this.sessionResponse = s.success;
          this.formatDates(s.success);
          console.log(s);
          for (const dataKey in s.success) { }
        }
      } else {
        console.log(this.Rc.getStringRC('global_message_' + dat.code));
        // tslint:disable-next-line:max-line-length
        this.messageService.clear();
        this.messageService.add({severity: 'error', summary: 'error', detail: this.Rc.getStringRC('global_message_' + dat.code), sticky: false});
      }
    });
    this.api.responseApiRegister$
      .subscribe(data => {
        console.log('data ws: ', data);
        const dat = JSON.parse(JSON.stringify(data));
        if (dat.code === 701) {
          
          sessionStorage.setItem('user', JSON.stringify(this.userData));
          this.messageService.clear();
          this.messageService.add({severity: 'success', summary: 'Exito', detail: 'Datos Actualizados exitosamente.', sticky: false});
          //this.setvalues();
        } else if (dat.code == 619) {
          // tslint:disable-next-line:max-line-length
          this.messageService.clear();
          this.messageService.add({severity: 'info', summary: 'Advertencia', detail: 'No hay cambios para actualizar.', sticky: false});
        } else {
          // tslint:disable-next-line:max-line-length
          this.messageService.clear();
          this.messageService.add({severity: 'error', summary: 'error', detail: 'Hubo un error en la actualización, por favor intente más tarde.', sticky: false});
        }
      });
  }

  formatDates(items:any) {
    items.map( (item:any) => {
      if (item.logs[0].date !== undefined) {
        let myDatePayment = item.logs[0].date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3");
        item.logs[0].date = this.dp.transform(myDatePayment, 'yyyy-MM-ddThh:mm', 'es-ES');
      }
    });
    this.sessionResponse = items;
    console.log("---- response ws: ----LIMPIO  ",this.sessionResponse);
  }

  test(event: any) {
    this.selectedType = event.option.value;
    if (this.selectedType === 1) {
      //cargar sesiones
      this.realm.getSessionSettings();
      //http://3.228.131.115/insured-access-web/api/v1/insuredSessionLog?policyCardNumber=502-567199&policyCountryCode=502&language=es
    }
  }
  setvalues() {
    const t =  this.items[0];
    this.userform.reset();
  }
  onSubmit(value: string) {
    this.submitted = true;
    //this.messageService.add({severity: 'info', summary: 'Success', detail: 'Form Submitted', sticky: false});
    const q = JSON.parse(JSON.stringify(value));
    console.log(q);
    this.userData.phoneNumber = q.country.idCode+q.phoneNumber;
    this.userData.documentId = q.dpi;
    this.userData.email = q.email;
    this.userData.phoneArea = q.country.idCode;
    this.realm.getRegisterSettings(q.country.idCode, q.phoneNumber, q.email, q.dpi, 'PUT');
    //this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Datos Actualizados exitosamente...', sticky: false});
    //this.realm.getRegisterSettings(q.country.idCode, q.phoneNumber, q.email, q.dpi, 'PUT');
  }
  deleteProduct(product: any) {
    console.log(product);
    console.log(this.sessionResponse);
    this.sessionResponse = this.sessionResponse.filter(val => val.description !== product.description);
    //this.sessionResponse = {};
    this.messageService.clear();
    this.messageService.add({severity: 'success', summary: 'Transacción exitosa', detail: 'Se ha eliminado el dispositivo', life: 3000});
    
  }
  deleteSelectedProducts() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete the selected products?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.sessionResponse = this.sessionResponse.filter(val => !this.selectedProducts.includes(val));
        this.selectedProducts = null;
        this.messageService.clear();
        this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000});
      }
    });
  }

  validate(evt) {
    var theEvent = evt || window.event;
    // Handle paste
    if (theEvent.type === 'paste') {
        //key = event.clipboardData.getData('text/plain');
    } else {
    // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
    }
    var regex = /[0-9]|\./;
    if( !regex.test(key) ) {
      theEvent.returnValue = false;
      if(theEvent.preventDefault) theEvent.preventDefault();
    }
  }
}
